// dependency-graph-ignore-file
import { viewToCollabJSON } from '@databases/collab/convert/to-collab';
import { type Database } from '@databases/model/database';

import { type DatabaseView } from '../../types';

export function addSavedView(ydb: Database, view: DatabaseView): void {
  ydb.mutate((db) => {
    db.addView(view.id, viewToCollabJSON(view, {}));
  });
}
